import { useEffect, useState } from "react";
import { useAuth } from "../../../provider/Auth.provider";
import styles from "../../../styles/DashboardStyles/Dashboard.module.css";
import Sidebar from "../../../components/FlowComponents/Sidebar/Sidebar";
import MobileSidebar from "../../../components/FlowComponents/MobileSidebar/MobileSidebar";
import Header from "./Header";
import SuperDa from "./SuperDash/SuperDashboard";
import SalesTarget from "./SaleTarget/SaleTarget";
import Logout from "../../../components/LogoutModal/Logout";
import logout from "../../../service/logout";
import { findUserByUID } from "../../../service/findUsers/findUserByUID";
import UserNotification from "../../../components/FlowComponents/userNotification/UserNotification";
import UserProfile from "../../../components/FlowComponents/userProfile/UserProfile";
import { sampleNotificationData } from "../../../service/notificationService/sampleNotificationData";
import AddTeamLeader from "../../../components/AdminComponents/AddTeamLeader/AddTeamLeader";

import dashActive from "./assets/dashActive.png";
import dashPng from "./assets/dash.png";
import CourseActive from "./assets/CourseActive.png";
import Course from "./assets/Course.png";
import GiftsActive from "./assets/giftActive.png";
import Gifts from "./assets/gift.png";
import PayoutsActive from "./assets/payoutActive.png";
import Payouts from "./assets/payout.png";
import SaleTargetActive from "./assets/SaleActive.png";
import SaleTarget from "./assets/Sale.png";
import Lms from "../../../components/AdminComponents/Lms/Lms";
import CourseList from "../../../components/AdminComponents/CourseList/Couselist";
import Gift from "../../../components/AdminComponents/Gift/Gift";
import Transactions from "../../../components/AdminComponents/Transactions/Transactions";
import Payments from "../../../components/AdminComponents/Payments/Payments";

const Dashboard = () => {
  const { user } = useAuth();
  const [userData, setUserData] = useState({});

  const [showModal, setShowModal] = useState(false);
  const [notifyModal, setNotifyModal] = useState(false);
  const [profileModal, setProfileModal] = useState(false);
  const [isMobileSidebarVisible, setIsMobileSidebarVisible] = useState(false);

  const [activeElement, setActiveElement] = useState("admindash");
  const [isMenuExpanded, setIsMenuExpanded] = useState(false);

  useEffect(() => {
    const fetchUserData = async () => {
      const userData = await findUserByUID(user.uid);
      setUserData(userData);
    };
    fetchUserData();
  }, [user]);

  useEffect(() => {
    const handleResize = () => {
      setIsMenuExpanded(false);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleClick = (element) => setActiveElement(element);

  const menuItems = [
    {
      key: "admindash",
      label: "Dashsssss",
      icon: dashPng,
      activeIcon: dashActive,
    },
    {
      key: "courselist",
      label: "Courses",
      icon: Course,
      activeIcon: CourseActive,
    },
    { key: "lms", label: "LMS", icon: Course, activeIcon: CourseActive },
    { key: "gift", label: "Gift", icon: Gifts, activeIcon: GiftsActive },
    {
      key: "payout",
      label: "Payout",
      icon: Payouts,
      activeIcon: PayoutsActive,
    },
    {
      key: "payments",
      label: "Payments",
      icon: Payouts,
      activeIcon: PayoutsActive,
    },
    {
      key: "transactions",
      label: "Transactions",
      icon: Payouts,
      activeIcon: PayoutsActive,
    },
    {
      key: "saletarget",
      label: "Sales",
      icon: SaleTarget,
      activeIcon: SaleTargetActive,
    },
    {
      key: "addTeamLeader",
      label: "Leader",
      icon: SaleTarget,
      activeIcon: SaleTargetActive,
    },
  ];

  return (
    <div className={`${styles.dashboard}`}>
      <Sidebar
        activeElement={activeElement}
        handleClick={handleClick}
        openModal={() => setShowModal(true)}
        isMenuExpanded={isMenuExpanded}
        menuItems={menuItems}
      />
      <div className={styles.maincontent}>
        <Header
          userData={userData}
          openNotifyModal={() => setNotifyModal(true)}
          openProfileModal={() => setProfileModal(true)}
          toggleMenu={() => setIsMenuExpanded(!isMenuExpanded)}
        />
        {activeElement === "admindash" ? <SuperDa /> : null}
        {activeElement === "courselist" ? <CourseList /> : null}
        {activeElement === `lms` ? <Lms /> : null}
        {activeElement === "gift" ? <Gift /> : null}
        {/* {activeElement === 'payout' ? <Payout /> : null} */}
        {activeElement === "payments" ? <Payments /> : null}
        {activeElement === "transactions" ? <Transactions /> : null}
        {activeElement === "saletarget" ? <SalesTarget /> : null}
        {activeElement === "addTeamLeader" ? <AddTeamLeader /> : null}
      </div>

      <MobileSidebar
        isVisible={isMobileSidebarVisible}
        onClose={() => setIsMobileSidebarVisible(false)}
        menuItems={menuItems}
        activeElement={activeElement}
        handleClick={setActiveElement}
        openModal={() => setShowModal(true)}
      />

      {/* this is modal, it will open when true, independent in itself */}
      <Logout
        showModal={showModal}
        closeModal={() => setShowModal(false)}
        handleLogout={logout}
      />
      <UserNotification
        showModal={notifyModal}
        closeModal={() => setNotifyModal(false)}
        sampleNotificationData={sampleNotificationData}
      />
      <UserProfile
        userData={userData}
        showModal={profileModal}
        closeModal={() => setProfileModal(false)}
      />
    </div>
  );
};

export default Dashboard;
